// libraries
import { generateUri } from "@cloudspire/legacy-shared/src/libraries";

// helpers
import {
  contentIsTypeCampaign,
  contentIsTypeCategory,
  contentIsTypeFree,
  contentIsTypePage,
} from "@cloudspire/legacy-resources/src/helpers/content";
import { nextRedirect } from "@cloudspire/legacy-resources/src/helpers/next";

/**
 * Redirige vers la page correspondant au type de contenu (si nécessaire).
 * @param {object} param0
 * @param {ReturnType<typeof import("@cloudspire/legacy-resources/src/normalizers/content/parseData").default>} param0.content
 * @param {Array<string>} param0.pageType
 * @param {any} param0.ctx
 * @param {any} param0.frontRouter
 * @param {string} param0.lang
 */
export default async function contentTypeRedirect({
  content,
  pageType,
  ctx,
  frontRouter,
  lang,
}) {
  let redirectUri;

  if (
    /** Si le type du contenu est différent de celui attendu. */
    !pageType.includes(content.type)
  ) {
    if (contentIsTypeCampaign({ content })) {
      redirectUri = generateUri({
        router: frontRouter,
        name: "App.Action.Campaign",
        parameters: {
          lang,
          slug: content.slug,
        },
      });
    } else if (
      contentIsTypeFree({ content }) ||
      contentIsTypePage({ content })
    ) {
      redirectUri = generateUri({
        router: frontRouter,
        name: "App.Action.Content",
        parameters: {
          lang,
          slug: content.slug,
        },
      });
    } else if (contentIsTypeCategory({ content })) {
      redirectUri = generateUri({
        router: frontRouter,
        name: "App.Action.RoomListWithSlug",
        parameters: {
          lang,
          slug: content.slug,
        },
      });
    }

    await nextRedirect({
      redirectionUri: redirectUri,
      code: 301,
      res: ctx.res,
    });
  } else {
    return false;
  }
}
